import type { CrudAdapter } from '@botto/core';
import { useCrudDataSource } from '@botto/core';
import { smsClient } from '../client';
import type { MessageTemplate, MessageTemplateCreate, MessageTemplateUpdate } from '../types';

export const messageTemplatesAdapter: CrudAdapter<
  MessageTemplate,
  MessageTemplateCreate,
  MessageTemplateUpdate
> = {
  async list({ offset, limit, sortName, sortDirection }) {
    const { data, error } = await smsClient.GET('/message_templates/', {
      params: {
        query: {
          offset,
          limit,
          'sort.name': sortName ?? 'id',
          'sort.direction': (sortDirection ?? 'asc') as 'asc' | 'desc',
        },
      },
    });
    if (error) throw error;
    return { items: data?.items ?? [], total: data?.total ?? 0 };
  },
  async create(payload) {
    const { data, error } = await smsClient.POST('/message_templates/', { body: payload });
    if (error) throw error;
    return { id: data?.id ?? 0 };
  },
  async update(payload) {
    const { data, error } = await smsClient.PUT('/message_templates/', { body: payload });
    if (error) throw error;
    return (data ?? payload) as MessageTemplate;
  },
  async byKey(id) {
    const { data, error } = await smsClient.GET('/message_templates/{item_id}', {
      params: { path: { item_id: Number(id) } },
    });
    if (error) throw error;
    return data as MessageTemplate;
  },
  async remove(id) {
    const { error } = await smsClient.DELETE('/message_templates/{item_id}', {
      params: { path: { item_id: Number(id) } },
    });
    if (error) throw error;
  },
};

export const messageTemplatesStore = useCrudDataSource(messageTemplatesAdapter);
